import { render, staticRenderFns } from "./ShoppinglistShare.vue?vue&type=template&id=59d953c6&"
import script from "./ShoppinglistShare.vue?vue&type=script&lang=js&"
export * from "./ShoppinglistShare.vue?vue&type=script&lang=js&"
import style0 from "./ShoppinglistShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports